import { render, staticRenderFns } from "./EstimateTaskItemMaterial.vue?vue&type=template&id=37d62527&"
import script from "./EstimateTaskItemMaterial.vue?vue&type=script&lang=js&"
export * from "./EstimateTaskItemMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports